import type { EventTicket } from '../api/events';

export type TicketSalesStatus = 'available' | 'not_started' | 'ended';

export function getTicketSalesStatus(ticket: EventTicket | undefined): TicketSalesStatus {
  if (!ticket) return 'available';
  const now = Date.now();
  if (ticket.expired_at) {
    const expiredAt = new Date(ticket.expired_at).getTime();
    if (!Number.isNaN(expiredAt) && expiredAt <= now) return 'ended';
  }
  if (!ticket.use_publish_time_for_start_at && ticket.start_at) {
    const startsAt = new Date(ticket.start_at).getTime();
    if (!Number.isNaN(startsAt) && startsAt > now) return 'not_started';
  }
  return 'available';
}
